import { StorageLike } from '../core/run-options';

/**
 * The last review run on a document, remembered per user in the browser (plan §4.4). Query Tool
 * sessions are per user anyway, so nothing here is shared; and storage may be unavailable, so
 * every access is guarded and the pane works without it.
 */

export interface LastReview {
  sessionId: string;
  ranAt: string;
  docType: string;
  /** The recommended action the run proposed, for the row's Response cell. */
  recommendedAction?: string;
}

export const lastReviewKey = (userId: string, documentId: string) =>
  `centerline-ai-review:${userId}:${documentId}`;

export function loadLastReview(
  storage: StorageLike | null,
  userId: string,
  documentId: string,
): LastReview | null {
  try {
    const raw = storage?.getItem(lastReviewKey(userId, documentId));
    if (!raw) return null;
    const v = JSON.parse(raw) as Partial<LastReview>;
    if (typeof v.sessionId !== 'string' || typeof v.ranAt !== 'string') return null;
    return {
      sessionId: v.sessionId,
      ranAt: v.ranAt,
      docType: typeof v.docType === 'string' ? v.docType : '',
      ...(typeof v.recommendedAction === 'string'
        ? { recommendedAction: v.recommendedAction }
        : {}),
    };
  } catch {
    return null;
  }
}

export function saveLastReview(
  storage: StorageLike | null,
  userId: string,
  documentId: string,
  review: LastReview,
): void {
  try {
    storage?.setItem(lastReviewKey(userId, documentId), JSON.stringify(review));
  } catch {
    // The review still ran; only "last run" is forgotten.
  }
}
